import Net from '../lib/net.js';
import { browserHistory } from 'react-router';
import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker,TrafficLayer,Polyline } from "react-google-maps";
import { jsonToCSVConvertor } from './jsonUtils';
import { DB } from "../db/dbschema";
import { TL_ROUTE_PATH, HARDWARE_TYPES } from '../lib/enums';
import { StampTODate, timeFormat } from '../lib/dtconv';
const crmhostname = require('../config').config.crmhostname;
var markerA = require('../images/greenMarker_s.png');
var markerB = require('../images/redMarker_s.png');

export function actionOnLogout(kick, cb) {
  global.gWebSocket = null;
  global.wsOnline = null;
  global.bikeDetails = null;
  if (global.userId) global.userId = null;
  if (document.referrer !== TL_ROUTE_PATH + "/") {
    window.history.pushState(null, null, TL_ROUTE_PATH + "/");
    window.addEventListener('popstate', () => {
      window.history.pushState(null, null, TL_ROUTE_PATH + "/");
    });
    window.removeEventListener('popstate', (e) => {
    });
  }
  if (global.indexedDbClient && !kick) {
    global.indexedDbClient.deleteDB(DB.GL, (err) => {
      if (err) console.error(err);
      else global.indexedDbClient = null;
      cb();
    });
  } else cb();
}

export function formatCurrency(amount, currency = 'INR', format = 'en-IN') {
  var formatter = new Intl.NumberFormat(format, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  });
  return (formatter.format(amount));
}

export function compareTwoArrays(arr1, arr2){
  var diff = false ;
  if(arr1.length === arr2.length) {
    arr1.forEach((v) => {
      if(!arr2.includes(v)){
        diff = true;
      }
    });
  }else diff = true;
  return diff;
}

export function logout(kick) {
  var url = crmhostname + "/crm/users/logout";
  Net.PostRequest(url, "", (resp) => {
    if(resp.status === 200){
      if (global.gWebSocket) {
        global.gWebSocket.closeWS();
      }
    }
    actionOnLogout(kick, () => {
      browserHistory.push(TL_ROUTE_PATH);
    });
  });
}

export const MapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap zoom={props.zoom} center={props.center} onZoomChanged={props.onZoomChanged}
    ref={props.referance} onIdle={props.onMapIdle} onMapMounted={props.onMapMounted}
    options={{ scaleControl: true, streetViewControl: false }}>

    <Marker position={props.regionA} icon={{ url: markerA, anchor: { x: 20, y: 40 } }} onClick={() => props._onChange} />

    <Marker position={props.regionB} icon={{ url: markerB, anchor: { x: 20, y: 40 } }} onClick={() => props._onChange} />

    {props.trafficCheck ? <TrafficLayer autoUpdate /> : null}

    {props.pathTrail && props.pathTrail.length
      ? <Polyline path={props.pathTrail} options={{ strokeColor: '#217dbb', geodesic: true }} />
      : null}

  </GoogleMap>
))

export function isVehValid(vehicles, vidArr) {
  var valid = false;
  if (vidArr && vidArr.length) {
    vehicles.forEach(vid => {
      if (vidArr.includes(vid.idx)) {
        valid = true;
      }
    });
    return valid;
  }
}

export function _setNewUrl(loc, vehArr, from, to) {
  var newUrl = loc.pathname;
  if (vehArr) {
    vehArr.forEach((veh, i) => {
      if (i === 0) newUrl += "?vid=" + veh;
      else newUrl += "&vid=" + veh;
    });
    if (from && to) newUrl += "&from=" + from + "&to=" + to;
  } else {
    if (from && to) newUrl += "?from=" + from + "&to=" + to;
  }
  if(loc.query && loc.query.noIgnition) newUrl +="&noIgnition=true";
  return newUrl;
}

export function getVidArray(vids) {
  //function accept vid from url and return vid array
  var vidArr = [];
  if (!Array.isArray(vids)) {
    vidArr.push(parseInt(vids));
  } else {
    vids.forEach(v => {
      vidArr.push(parseInt(v));
    });
  }
  return (vidArr);
}

export function getDevices(vehicles ) {
  /*
  Fucntion get all vehicles as input,
  return length and boolean value for device availablity
 */
  var devices = [];
  if (vehicles && vehicles.length) {
    vehicles.forEach(veh => {
      if (veh.dev && Object.keys(veh.dev).length) devices.push(veh.dev);
    });
    return devices;
  } else return devices;
}

export function downloadRidesCSV(pingArr, title, heading, hwtyp) {
  var excelData = pingArr.map((data) => {
    var obj = {};
    obj['TIMESTAMP'] = data.ts;
    obj['DATE_TIME'] = StampTODate(data.ts * 1000) + " " + timeFormat(data.ts * 1000, true);
    obj['LAT'] = data.lat;
    obj['LNG'] = data.lng;
    obj['SPEED'] = data.spd;

    if (hwtyp == HARDWARE_TYPES.WIRELESS) {
      return obj;
    } else if (hwtyp == HARDWARE_TYPES.AJJAS_LITE) {
      obj['IGNITION'] = data.ignition;
      return obj;
    } else {
      obj['ALT'] = data.alt;
      obj['BRG'] = data.brg;
      obj['HEPE'] = data.hepe;
      obj['VEPE'] = data.vepe;
      obj['ANGLE'] = data.ang;
      obj['TEMP'] = data.temp;
      obj['MOTION'] = data.motion;
      obj['MAINPOWER'] = data.mainPower;
      obj['RELAYSTATE'] = data.relayState;
      obj['IGNITION'] = data.ignition;
      return obj;
    }
  });
  jsonToCSVConvertor(excelData, title + Date.now(), true, heading);
}

export function isValidFromTS(qsFrom, fromLimit) {
  if (qsFrom < fromLimit) return false;
  else return true;
}

export function isValidToTS(qsTo, toLimit) {
  if (qsTo > toLimit) return false;
  else return true;
}

export function getNfTypeArray(qsNfTypes) {
  //function accept query string from url and return notif type array
  var nfTypesArr = [];
  if (!Array.isArray(qsNfTypes)) {
    nfTypesArr.push(parseInt(qsNfTypes));
  } else {
    qsNfTypes.forEach(n => {
      nfTypesArr.push(parseInt(n));
    });
  }
  return (nfTypesArr);
}

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent;

  if (/android/i.test(userAgent) || /Win32|Win64|Windows|WinCE/.test(userAgent)) return "Android";
  if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) return "iOS";

  return "unknown";
}